import { assets } from '../assets'

import {
  Object3D,
  Box3,
  TextureLoader,
  PlaneBufferGeometry,
  MeshStandardMaterial,
  Mesh
} from 'three'

import { Station } from '@/webGL/objects/Station.js'

export class EnvironmentStation extends Object3D {
  constructor () {
    super({name: 'EnvironmentStation'})

    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
    this.promises = []

    this.station = new Station()
    this.add(this.station)
    this.promises.push(this.station.promise)

    const geo = new PlaneBufferGeometry(150, 150, 1, 1)
    const mat = new MeshStandardMaterial({
      color: 0xcccccc
    })
    this.plane = new Mesh(geo, mat)
    this.plane.rotation.x = -Math.PI * .5
    this.plane.position.y = -1
    this.plane.receiveShadow = true
    this.add(this.plane)

    Promise.all(this.promises).then(this.resolve)
  }

  get opacity () {
    return this._opacity
  }

  set opacity (opacity) {
    this._opacity = opacity
    this.traverse((child) => {
      child.isMesh && child.material.color.setRGB(opacity, opacity, opacity)
    })
  }

  animate () {
    gsap.to(this, 2, {
      opacity: 1,
      ease: 'easeOutQuad'
    })
  }
}
